module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_8017.312d6bfa.png";